// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"765d1194","524":"e163e7c8","719":"d1c90959","978":"9d1f971a"}[chunkId] + ".chunk.js";
};